import { SubmissionActions, MoretonBaySubmissionActions } from '@ctct/presentation-layer';

import type { UpdateBillingWidgetProps } from './useUpdateBillingWidget';

export const UpdateBillingWidget = ({
  hooks,
  handlers,
  version = 'billing-info',
}: UpdateBillingWidgetProps & { version?: 'billing-info' | 'moreton-bay' }) => {
  const isLoading = hooks.useIsLoading();
  const formIsDirty = hooks.useFormIsDirty();
  const paymentCanChange = hooks.usePaymentCanChange();

  if (version === 'moreton-bay') {
    return (
      <MoretonBaySubmissionActions
        isLoading={isLoading}
        allowSave={formIsDirty || paymentCanChange}
        onUpdateInfo={handlers.onSubmitClicked}
      />
    );
  }

  return (
    <SubmissionActions
      isLoading={isLoading}
      allowSave={formIsDirty || paymentCanChange}
      onCancel={handlers.onExitClicked}
      onUpdateInfo={handlers.onSubmitClicked}
    />
  );
};
